import apiV2 from '../../../api-v2';
import crm from '../../../api/crm';
import crmFilterKey from '../../constants-v2/filters/crm-filter-key.js';
import HttpBuildQuery from '../../procedures/http-build-query';
import FiltersType from './listingFiltersTypesConstants';
import { getCrmCustomerTypeOptions } from '../../constants-v2/filters/crm-filter-customer-types.js';

export const CLIENTS_LISTING_FILTERS = {
  path: '/clients',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'client.person.company.vat_payer',
      getItems: async () => [{ value: 0, label: 'Nie jest płatnikiem VAT' }, { value: 1, label: 'Jest płatnikiem VAT' }],
      reset: async () => null,
      placeholder: 'Czy jest płatnikiem VAT?',
      badge: 'Płatnik VAT:',
      testName: 'dropdown_list_filter_vat_payer',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'client.person.personstatustype.name',
      getItems: async () => [{ value: 'aktywny', label: 'Aktywny' }, { value: 'nieaktywny', label: 'Nieaktywny' }],
      reset: async () => null,
      placeholder: 'Czy jest aktywny?',
      badge: 'Status kontrahenta:',
      testName: 'dropdown_list_filter_client_status',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_is_company',
      getItems: async () => [{ value: 0, label: 'Osoba fizyczna' }, { value: 1, label: 'Firma' }],
      reset: async () => null,
      placeholder: 'Firma czy Os. fizyczna?',
      badge: 'Rodzaj kontrahenta:',
      testName: 'dropdown_list_filter_is_company',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'client.person.company.form_of_accounting.name',
      getItems: async () => [{ value: 'ryczałt', label: 'Ryczałt' }, { value: 'kpir', label: 'KPiR' }, {
        value: 'Księgi handlowe',
        label: 'Księgi handlowe',
      }],
      reset: async () => null,
      placeholder: 'Forma księgowości',
      badge: 'Forma księgowości:',
      testName: 'dropdown_list_filter_form_of_accounting',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_has_agreement',
      getItems: async () => [{ value: 1, label: 'Jest umowa' }, { value: 0, label: 'Brak umowy' }],
      reset: async () => null,
      placeholder: 'Czy jest umowa?',
      badge: 'Umowa:',
      testName: 'dropdown_list_filter_has_agreement',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: '_attendant_original_ids',
      placeholder: 'Przypisany pracownik',
      testName: 'dropdown_list_filter_employee',
      reset: async () => null,
      getItems: async () => {
        let { data } = await apiV2.staff.staff.list(HttpBuildQuery({ list: true }));
        delete data.pagination;

        return Object.values(data)
          .map((item) => {
            return {
              value: item.employee.person.original,
              label: `${ item.employee.person.name } ${ item.employee.person.surname }`,
            };
          });
      },
      badge: 'Pracownik:',
      hasExternalValue: true,
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'status.id',
      placeholder: 'Status CRM',
      testName: 'dropdown_list_filter_crm_status',
      reset: async () => null,
      getItems: async () => {
        let { data } = await crm.STATUS.index();
        delete data.pagination;

        return Object.values(data)
          .map((item) => {
            return {
              value: item.id,
              label: item.label,
            };
          });
      },
      badge: 'Status CRM:',
      hasExternalValue: true,
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: crmFilterKey.CUSTOMER_TYPE,
      placeholder: 'Typ kontrahenta',
      testName: 'dropdown_list_filter_crm_customer_type',
      reset: async () => null,
      getItems: getCrmCustomerTypeOptions,
      badge: 'Typ kontrahenta:',
      hasExternalValue: true,
      inputType: FiltersType.SELECT_TYPE,
    },
  ],
};
